import axios from "axios";
import { API_CONFIG, API_ENDPOINTS, ERROR_MESSAGES } from "../constants";

// Create axios instance for chat API
const chatApiClient = axios.create({
  baseURL: API_CONFIG.BASE_URL_FOR_CHAT,
  timeout: API_CONFIG.TIMEOUT,
  headers: {
    "Content-Type": "application/json",
    "x-secret-key": "8E23DE2A19E38",
  },
});

// Create axios instance for backend API
const backendApiClient = axios.create({
  baseURL: API_CONFIG.BASE_URL_FOR_BACKEND,
  timeout: API_CONFIG.TIMEOUT,
  headers: {
    "Content-Type": "application/json",
    "X-Api-Key": "x5sMtuMQm580phJFAsJaliF7b",
  },
});

// Request interceptors for logging
const requestInterceptor = (config) => {
  return config;
};

const requestErrorInterceptor = (error) => {
  console.error("API Request Error:", error);
  return Promise.reject(error);
};

chatApiClient.interceptors.request.use(
  requestInterceptor,
  requestErrorInterceptor
);
backendApiClient.interceptors.request.use(
  requestInterceptor,
  requestErrorInterceptor
);

// Response interceptors for error handling
const responseInterceptor = (response) => {
  return response;
};

const responseErrorInterceptor = (error) => {
  console.error("API Response Error:", error.response?.data || error.message);
  return Promise.reject(error);
};

chatApiClient.interceptors.response.use(
  responseInterceptor,
  responseErrorInterceptor
);
backendApiClient.interceptors.response.use(
  responseInterceptor,
  responseErrorInterceptor
);

/**
 * API service for survey and chat operations
 */
export const apiService = {
  async fetchSurveyData(surveyId) {
    try {
      const response = await backendApiClient.get(
        `/zoho-response?user_id=${surveyId}`
      );
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.message || ERROR_MESSAGES.SURVEY_FETCH_FAILED
      );
    }
  },

  async generateQuestions(surveyData) {
    try {
      const response = await chatApiClient.post(
        API_ENDPOINTS.GENERATE_QUESTIONS,
        {
          survey_data: surveyData,
        }
      );
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.message ||
          ERROR_MESSAGES.QUESTIONS_GENERATION_FAILED
      );
    }
  },

  async sendChatMessage(sessionId, answer, question) {
    try {
      const response = await chatApiClient.post(API_ENDPOINTS.CHAT, {
        session_id: sessionId,
        answer: answer,
        question: question,
      });
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.message || ERROR_MESSAGES.CHAT_MESSAGE_FAILED
      );
    }
  },

  async saveConversation(userId, conversation, summary) {
    try {
      const response = await backendApiClient.post("/survey-chat", {
        user_id: userId,
        conversation: conversation,
        summary: summary,
      });
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.message || "Failed to save conversation"
      );
    }
  },

  async getChatHistory(userId) {
    try {
      const response = await backendApiClient.get(`/survey-chat/${userId}`);
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.message || "Failed to load chat history"
      );
    }
  },
};

// Export individual functions for convenience
export const {
  fetchSurveyData,
  generateQuestions,
  sendChatMessage,
  saveConversation,
  getChatHistory,
} = apiService;

// Export default service
export default apiService;
